import React from 'react';
import { useQuery } from 'react-fetching-library';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';

import { getPromotionStatisticsDataAction } from '../../../../services/request';
import { promotionStatisticsColumns } from '../../../../services/column-definitions';
import { Box } from '@mui/material';

export const PromotionStatistics = props => {
  const { loading, payload, error } = useQuery(getPromotionStatisticsDataAction());
  const [data, setData] = React.useState([]);
  const [columns, setColumns] = React.useState(promotionStatisticsColumns());


  React.useEffect(() => {
    if (!error && !loading) {
      setData(payload);
    }
  }, [loading]);


  return (
    <Box sx={{ minWidth: 800 }}>
      <DataGridPro
        columns={columns}
        rows={data}
        density="compact"
        disableColumnMenu={true}
        autoPageSize={false}
        autoHeight={true}
        rowsPerPageOptions={[10, 25, 50, 100]}
        localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
        disableSelectionOnClick
      />
    </Box>
  );
};
